import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { MainApiResponse } from './main.entity';

@Injectable()
export class MainService extends AbstractService {
  getBanners(refCode: string|null, marketingCode: string|null): Observable<MainApiResponse.Banners> {
    return this.get('/news/banners', { refCode, marketingCode });
  }

  getLiveDrops(): Observable<MainApiResponse.LiveDrops> {
    return this.get('/live-drops/list');
  }
}